/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


  import { G3W_FID, PAGELENGTHS, TIMEOUT } from 'g3w-constants';
  import ApplicationState                  from 'g3w-state';
  import Component                         from 'g3w-component';
  import Field                             from 'components/FieldG3W.vue';
  import { FieldsService }                 from 'components/g3w-fields';
  import GUI                               from 'g3w-app';
  import { debounce }                      from 'utils/debounce';
  import { getCatalogLayerById }           from 'utils/getCatalogLayerById';
  import { createRelationsUrl }            from 'utils/createRelationsUrl';
  import { getAlphanumericProps }          from 'utils/getAlphanumericProps';
  import { saveBlob }                      from 'utils/saveBlob';

  const __vue_script__ = {

    /** @since 3.8.6 */
    name: 'relation',

    components: {
      Field,
    },

    data() {
      const layer = getCatalogLayerById(this.$options.nmRelation?.referencedLayer || this.$options.relation?.referencingLayer || this.$options.layerId);

      return {

        layer,

        /**
         * @since 4.0.0
         */
        ApplicationState,

        /**
         * @since 4.0.0 chart state (action button)
         */
        chart: {
          toggled: false,
        },

        /**
         * @since 3.11.2 table state
         */
        table: {
          layerId:       layer.getId(),
          features:      [],
          page:          1,
          allfeatures:   0,
          page_size:     layer.getAttributeTablePageLength() || PAGELENGTHS[1],
          rows:          [],
          rows_fid:      [],
          ordering:      [-1, 'asc'],
          hasfeatures:   false, //@since 4.1.0 store if there are relations one mount (no change when filter table rows)
        },

        /**
         * @since 4.1.0
         */
        PAGELENGTHS,

        /**
         * @since 4.1.0
         */
        feature:     this.$options.feature ?? null,

        /**
         * @since 4.1.0
         */
        relation:    this.$options.relation ?? null,

        /**
         * @since 4.1.0
         */
        relations: !this.$options.relation && ((ApplicationState.project.getRelations() || []).reduce((group, r) => {
          group[r.referencedLayer] = group[r.referencedLayer] || [];
          group[r.referencedLayer].push(r);
          return group;
        }, {})[this.$options.layerId] || [])
          .filter(r => 'MANY' === r.type)
          .sort((a, b) => a.name.localeCompare(b.name)),

        /**
         * @since 4.1.0
         */
        layerId:     this.$options.layerId,
      };
    },

    computed: {

      /**
       * @returns { number } count of available tools (editing icon, form structure, zoom to feature, ...)
       *
       * @since 3.9.0
       */
      showTools() {
        return [!!this.isEditable, !!this.form_structure, !!this.table.features?.some(f => f.geometry)].filter(Boolean).length;
      },

      /**
       * @since 4.1.0
       */
      pages() {
        return Math.ceil(this.table.allfeatures / this.table.page_size);
      },

      /**
       * @since 4.1.0
       */
      nmRelation() {
        return ApplicationState.project.getRelationById(this?.relation?.nmRelationId);
      },

      /**
       * @since 4.1.0
       */
      download_formats() {
        return this.layer.getDownloadFormats().filter(f => 'pdf' !== f); // exclude pdf because already includes all features
      },

      /**
       * @since 4.1.0
       */
      form_structure() {
        return this.layer.getLayerEditingFormStructure();
      },

      /**
       * @since 4.1.0
       */
      columns() {
        return this.layer.getTableHeaders();
      },

      /**
       * @returns { boolean } whether relation layer is editable
       * 
       * @since 4.1.0 
       */
      isEditable() {
        return this.layer.isEditable() && !this.layer.isInEditing();
      },

      /**
       * @since 4.1.0
       */
      featureId() {
        return this.feature.attributes[G3W_FID] ?? this.feature.attributes.fid;
      },

      /**
       * @since 4.1.0
       */
      charts() {
        if (this.relation) {
          return GUI.plotLayerIds.find(pid => this.relation.referencingLayer == pid) ? [this.relation.referencingLayer] : [];
        } else {
          return this.relations.map(r => GUI.plotLayerIds.find(id => r.referencingLayer === id)).filter(Boolean);
        }
      },

      /**
       * @since 4.1.0
       */
      has_charts() {
        return !!this.charts.find(id => this.relation?.referencingLayer === id);
      },

      /**
       * @since 4.1.0
       */
      parent_layer() {
        return getCatalogLayerById(this.$options.layerId);
      }

    },

    watch: {
      async 'table.page_size'() {
        this.getData();
      },
      async 'table.page'(page) {
        this.getData({ page, ordering: this.table.ordering[0] });
      },
    },

    methods: {

      /**
       * @param relation
       * 
       * @since 4.1.0
       */
      async showRelation(relation) {
        GUI.showRelations({
          relationId: relation.id,
          layerId:    this.layerId,
          feature:    this.feature,
          push:       true
        });
      },

      /**
       * Preview feature attributes [max. 3]
       * 
       * @since 4.1.0
       */
      feature_info() {
        const attributes = Object.entries(this.feature.attributes)
        return this.parent_layer
          .getFields()
          .map(f => ({ label: f.label, value: attributes.find(([ key ]) => f.name === key)?.[1] }))
          .filter(({ value }) => (![undefined, null, ''].includes(value) && !`${value}`.includes('/')))
          .slice(0,3);
      },

     /**
      * @param { Object } geometry
      * @param geometry.type        Point, MultiPoint, etc ...
      * @param geometry.coordinates
      *
      * @since 3.9.0
      */
      zoomToGeometry(geometry) {
        if (geometry) {
          const geom = new ol.geom[geometry.type](geometry.coordinates);
          GUI.zoomToExtent(geom?.getExtent(), { highlight: true, highLightGeometry: geom });
        }
      },

      /**
       * @param { number } index column index
       */
      sortColumn(index) {
        if (index === this.table.ordering[0]) {
          this.table.ordering[1] = 'asc' === this.table.ordering[1] ? 'desc' : 'asc';
        } else {
          this.table.ordering[0] = index;
          this.table.ordering[1] = 'asc';
        }
        this.getData({ ordering: index });
      },

      /**
       * Fetch data from server
       * 
       * @param opts
       * @param { number } opts.ordering
       * @param { number } opts.page current page
       * 
       * @since 4.0.0
       */
      async getData({
        ordering  = -1,
        page      = 1,
      } = {}) {
        GUI.setLoadingContent(true);
        GUI.disableContent(true);

        try {
          // get relations from server
          const response = await (await fetch(createRelationsUrl({
              layerId:  this.layerId,
              fid:      this.featureId,
              relation: this.relation,
            }), {
            method:  'POST',
            headers: { 'Content-Type': 'application/json' },
            body:    JSON.stringify({
              page,
              page_size: this.table.page_size,
              formatter: 1,
              ordering:  ordering < 0 ? undefined : ('asc' === this.table.ordering[1] ? '' : '-') + this.columns[ordering].name,
              field:     this.columns?.filter(c => c.search).map(c => `${c.name}|ilike|${c.search}`).join('|AND,') || undefined,
            }),
          })).json();

          // extract features attributes
          let features = (response?.vector?.data?.features || []).map(f => ({
            id:         f.id,
            geometry:   f.geometry,
            attributes: Object.assign(f.properties, { [G3W_FID]: f.id }),
          }));

          // handle NM relations
          if (this.nmRelation && features.length) {
            features = (await GUI.getData('search:features', {
              inputs: {
                layer:     getCatalogLayerById(this.nmRelation.referencedLayer),
                filter:    features.map(f => `${this.nmRelation.fieldRef.referencedField}|eq|${encodeURIComponent(f.attributes[this.nmRelation.fieldRef.referencingField])}`).join(`|OR,`),
                formatter: 1,
              },
              outputs: null
            })?.data?.[0]?.features || []).map(f => ({
              id:         f.getId(),
              geometry:   f.getGeometry(),
              attributes: getAlphanumericProps(f.getProperties()).reduce((props, p) => Object.assign(props, { [p]: f.get(p)}), {}),
            }));
          }

          this.table.allfeatures = response?.vector?.count;
          this.table.features    = features;
          this.table.rows        = features.map(f => this.columns.filter(h => h).map(h => (h.value = (f.attributes || f.properties)[h.name])))
          this.table.rows_fid    = features.map(r => r.attributes[G3W_FID]);
          this.table.page        = page;

        } catch(e) {
          console.warn(e);
        }

        GUI.setLoadingContent(false);
        GUI.disableContent(false);
      },

      /**
       * @param i index
       */
      async showForm(i) {
        GUI.showContent({
          content: new Component({
            internalComponent: new (Vue.extend({
              data: () => ({
                layerid:        this.table.layerId,
                feature:        this.table.features[i],
                fields:         this.columns.map(c => Object.assign(c, {
                  value: this.table.features[i].attributes[c.name],
                  query: true,
                  input: {
                    type: `${FieldsService.getType(c)}`
                  }
                })),
                form_structure:    this.form_structure,
                feature_info:      this.feature_info(),
                relation_name:     this.relation.name,
                parent_layer_name: this.parent_layer.getName(),
              }),
              template: /* html */`
                <div class = "queryresults-wrapper">
                  <div class = "queryresults-container">
                    <div class = "header skin-background-color lighten" style="margin: 5px 0 10px 0; padding: 5px;">
                      <span style = "font-size: 1.1em;"><b>{{ relation_name }}</b> {{ $t('associated with the element') }} <b>{{ parent_layer_name }}</b></span>
                      <ul style = "padding: 0 0 0 25px; list-style: square;">
                        <li v-for = "({ label, value }) in feature_info"><b>{{ label }}</b>: {{ value }}</li>
                      </ul>
                    </div>
                    <div class = "g3w-long-text" style="font-size: 1.3em;padding: 8px 3px;">
                      <b class = "relation-tile"> {{ relation_name }} ({{ feature.id }})</b>
                    </div>
                    <table ref = "table" class="table">
                      <tbody>
                        <tr class="featurebox-body">
                          <td>
                            <tabs
                              :layerid = "layerid"
                              :feature = "feature"
                              :fields  = "fields"
                              :tabs    = "form_structure"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              `,
              async mounted() {
                await this.$nextTick();
                this.$refs.table.click();
              }
            }))
          }),
          title:      this.table.features[i].id,
          text:       true,
          push:       true,
          showgoback: true,
        });
      },

      /**
       * @param index
       */
      editFeature(index) {
        GUI.editFeature({
          layer: {
            id:         this?.nmRelation?.referencedLayer ?? this.relation.referencingLayer,
            attributes: this.columns,
          },
          feature: this.table.features[index],
        });
      },

      onChartResize() {
        const move = e => {
          const perc                     =  (Math.abs(e.x - window.innerWidth) * 100 / this.$refs.wrapper.clientWidth); // percentage
          this.$refs.content.style.width = `${100 - perc}%`;
          this.$refs.chart.style.width   = `${perc}%`;
        };
        const el = document.getElementById('g3w-view-content');
        el.addEventListener('mousemove', move);
        el.addEventListener('mouseup', async () => { 
          el.removeEventListener('mousemove', move); 
          await this.$nextTick();
          GUI.emit('resize') 
        }, { once: true });
      },

      /**
       * @since 4.1.0
       */
      async showDownloadModal() {
        const _   = g3w.gettext;

        let layer = getCatalogLayerById(this.nmRelation?.referencedLayer || this.relation?.referencingLayer || this.layerId);
        layer     = layer.state;

        if (!layer) {
          throw 'no layer';
        }

        const catalog_layer  = getCatalogLayerById(layer.id);

        const dialog = Object.assign(document.createElement('template'), {
          innerHTML: /* html */`
            <dialog>
              <h4 style="margin: 0; padding: .5em; color: #FFF; position: sticky; top: 0; background-color: #212c31"><i class="fas fa-download" style="margin-right: .5ch;"></i> ${ _('Export features') }</h4>
              <form method="dialog">

                <div class="form-group">
                  <label>${ _('Layer') }</label>
                  <select name="layer" class="form-control" disabled>
                    <option value="${layer.id}" selected>${ layer.name || layer.title } (${ this.layerId })</option>
                  </select>
                </div>

                <div class="form-group">
                  <label>${ _('Data Format') }</label>
                  <select name="format" class="form-control">
                    ${[
                        catalog_layer?.isGeoTIFFDownloadable?.() ? /* html */`<option value="GeoTiff">${ _('GeoTiff') }</option>` : '',
                        catalog_layer?.isShpDownloadable?.()     ? /* html */`<option value="Shp">${ _('Shapefile') }</option>` : '',
                        catalog_layer?.isGpxDownloadable?.()     ? /* html */`<option value="Gpx">${ _('GPX') }</option>` : '',
                        catalog_layer?.isGpkgDownloadable?.()    ? /* html */`<option value="Gpkg">${ _('GeoPackage') }</option>` : '',
                        catalog_layer?.isCsvDownloadable?.()     ? /* html */`<option value="Csv">${ _('CSV') }</option>` : '',
                        catalog_layer?.isXlsDownloadable?.()     ? /* html */`<option value="Xls">${ _('Excel') }</option>` : '',
                      ].filter(Boolean).join('')
                    }
                  </select>
                </div>

                <menu style="display: flex; justify-content: space-between;">
                  <button id="confirm_button" type="submit" value="confirm" class="btn btn-block btn-success">Download</button>
                </menu>
              </form>

            </dialog>
          `.trim()
        }).content.firstChild;

        dialog.addEventListener("click", e => {
          if (e.target === dialog) {
            dialog.close();
          }
        });

        dialog.addEventListener('close', async () => {
          if ('confirm' === dialog.returnValue) {

            ApplicationState.download = true;
            try {
              const format   = dialog.querySelector('[name="format"]').value.toLowerCase();

              const response = await fetch(createRelationsUrl({
                  layerId:  this.layerId,
                  fid:      this.featureId,
                  relation: this.relation,
                  type:     format
                }), {
                method:  'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Access-Control-Expose-Headers': 'Content-Disposition', // get filename from server
                },
                body: JSON.stringify({ formatter: 1 }),
                signal: AbortSignal.timeout(TIMEOUT),
              });

              if (!response?.ok) {
                throw (await response.json()).message;
              }

              saveBlob(await response.blob(), response.headers.get('content-disposition').split('filename=').at(-1));

            } catch(e) {
              console.warn(e);
              GUI.showUserMessage({
                type:     'alert',
                message:  e ?? 'server_error',
                closable: true,
              });
            }

            ApplicationState.download = false;
          }
          dialog.remove();
        });

        document.body.appendChild(dialog);
        dialog.showModal();
      },

      /**
       * @since 4.1.0
       */
      async toggleChart() {
        this.chart.toggled = !this.chart.toggled;
        await this.$nextTick();
        this.chart.container = this.chart.container || document.querySelector('#chart_content');
        if (this.chart.toggled) {
          GUI.showChart([this.relation.referencingLayer], this.chart.container, { relations: [this.relation], fid: this.featureId });
        } else {
          GUI.hideChart(this.chart.container);
        }
      },

    },

    async mounted() {
      this.changeColumn = debounce((e, i) => {
        this.columns[i].search = e.target.value.trim();
        this.getData();
      });

      // autoload selected relation
      if (this.relation) {
        this.relation.title = this.relation.name;
        if ('ONE' !== this.relation.type) {
          this.getData();
          //set first time load
          this.table.hasfeatures = this.table.rows.length > 0;
        }
      }
    },

    /**
     * @fires hide-chart
     */
    async beforeDestroy() {
      // hide opened chart
      if (this.chart.toggled) {
         GUI.hideChart(this.chart.container);
      }
      if (this.chart.container) {
        this.$emit('hide-chart', this.chart.container);
        this.chart.container = null;
      }
      // reset columns search
      this.columns.forEach(c => delete c.search); 
      if (1 === this.relations.length) {
        delete this.relations[0].noback;
      }
    },

  };

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.relations)?_c('div',{staticClass:"layer-relations"},[_c('div',{staticClass:"header skin-background-color lighten"},[_c('span',{staticStyle:{"font-size":"1.1em"}},[_vm._v(_vm._s(_vm.$t('List of relations of feature'))+" "),_c('b',[_vm._v(_vm._s(_vm.parent_layer.getName()))])]),_vm._v(" "),_c('ul',{staticStyle:{"padding":"0 0 0 25px","list-style":"square"}},_vm._l((_vm.feature_info()),function(ref){
var label = ref.label;
var value = ref.value;
return _c('li',[_c('b',[_vm._v(_vm._s(label))]),_vm._v(": "+_vm._s(value))])}),0)]),_vm._v(" "),_c('div',{staticStyle:{"display":"grid","grid-template-columns":"repeat(2, auto)","grid-column-gap":"5px","grid-row-gap":"5px"}},_vm._l((_vm.relations),function(relation){return _c('button',{staticClass:"skin-border-color grid-item",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.showRelation(relation)}}},[_c('i',{staticClass:"fas fa-sitemap",staticStyle:{"padding":"6px"},attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('b',{staticStyle:{"padding":"5px","overflow":"hidden","white-space":"normal","overflow-wrap":"break-word"}},[_vm._v(_vm._s(relation.name))])])}),0)]):(_vm.relation)?_c('div',{staticClass:"layer-relation"},[_c('div',{staticClass:"header skin-background-color lighten"},[_c('span',{staticStyle:{"font-size":"1.1em"}},[_c('b',[_vm._v(_vm._s(_vm.relation.name))]),_vm._v(" "+_vm._s(_vm.$t('associated with the element'))+" "),_c('b',[_vm._v(_vm._s(_vm.parent_layer.getName()))])]),_vm._v(" "),_c('ul',{staticStyle:{"padding":"0 0 0 25px","list-style":"square"}},_vm._l((_vm.feature_info()),function(ref){
var label = ref.label;
var value = ref.value;
return _c('li',[_c('b',[_vm._v(_vm._s(label))]),_vm._v(": "+_vm._s(value))])}),0)]),_vm._v(" "),_c('div',{staticClass:"sub-header"},[_c('div',{staticClass:"g3w-long-text"},[_c('b',{staticClass:"relation-tile"},[_vm._v(" "+_vm._s(_vm.relation.name)+" ")])]),_vm._v(" "),_c('div',{staticClass:"table-tools"},[_c('button',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.table.hasfeatures && (!_vm.download_formats.length || _vm.ApplicationState.download)),expression:"!table.hasfeatures && (!download_formats.length || ApplicationState.download)"}],staticClass:"action-button fas fa-download",attrs:{"type":"button","title":"Downloads","data-placement":"left"},on:{"click":function($event){$event.stopPropagation();return _vm.showDownloadModal.apply(null, arguments)}}}),_vm._v(" "),_c('button',{directives:[{name:"disabled",rawName:"v-disabled",value:(!_vm.table.hasfeatures && !_vm.has_charts),expression:"!table.hasfeatures && !has_charts"}],staticClass:"action-button fas fa-chart-bar",class:[ _vm.chart.toggled ? 'toggled-white' : '' ],attrs:{"title":"Show Chart","data-placement":"bottom"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleChart.apply(null, arguments)}}})])]),_vm._v(" "),_c('div',{ref:"wrapper",staticClass:"relation-table"},[_c('div',{ref:"content",style:({
        width:         _vm.chart.toggled ? '70%' : '100%',
        display:       'flex',
        flexDirection: 'column',
      })},[_c('span',[_vm._v(_vm._s(_vm.table.allfeatures)+" "+_vm._s(_vm.$t('entries')))]),_vm._v(" "),_c('table',{ref:"table"},[_c('thead',[_c('tr',{staticStyle:{"height":"0! important"}},[(_vm.showTools)?_c('th',{style:({
                minWidth: _vm.showTools * 30 + 'px',
                padding:  '0 !important',
              })}):_vm._e(),_vm._v(" "),_vm._l((_vm.columns),function(c,i){return _c('th',{class:[i === _vm.table.ordering[0] ? _vm.table.ordering[1] : '' ],style:({'width': ((100 / _vm.columns.length) + "%")}),attrs:{"title":_vm.$t('sort by:') + ' ' + c.label,"data-placement":"top"},on:{"click":function($event){$event.stopPropagation();return _vm.sortColumn(i)}}},[_vm._v(_vm._s(c.label))])})],2),_vm._v(" "),_c('tr',[(_vm.showTools)?_c('th'):_vm._e(),_vm._v(" "),_vm._l((_vm.columns),function(c,i){return _c('th',[_c('input',{staticClass:"form-control column-search",attrs:{"type":"text","placeholder":c.name,"title":_vm.$t('search by:') + ' ' + c.name},domProps:{"value":c.search},on:{"keyup":function($event){return _vm.changeColumn($event, i)}}})])})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.table.rows),function(row,i){return _c('tr',{key:_vm.table.rows_fid[i]},[(_vm.showTools)?_c('td',{staticClass:"table-tools"},[(_vm.table.features[i].geometry)?_c('span',{staticClass:"action-button row-form skin-color fas fa-map-marker-alt",attrs:{"title":"Zoom to Geometry","data-placement":"right"},on:{"click":function($event){$event.stopPropagation();return _vm.zoomToGeometry(_vm.table.features[i].geometry)}}}):_vm._e(),_vm._v(" "),(_vm.form_structure)?_c('span',{staticClass:"action-button row-form skin-color fas fa-table",attrs:{"title":"Form View","data-placement":"right"},on:{"click":function($event){$event.stopPropagation();return _vm.showForm(i)}}}):_vm._e(),_vm._v(" "),(_vm.isEditable)?_c('span',{staticClass:"action-button row-form skin-color fas fa-pencil-alt",attrs:{"title":"Edit","data-placement":"right"},on:{"click":function($event){$event.stopPropagation();return _vm.editFeature(i)}}}):_vm._e()]):_vm._e(),_vm._v(" "),_vm._l((row),function(value){return _c('td',[_c('field',{attrs:{"state":{ value: value }}})],1)})],2)}),0)]),_vm._v(" "),_c('div',{staticClass:"table-toolbar",staticStyle:{"display":"flex","gap":"1ch","margin-top":"1ch"}},[_c('label',{staticStyle:{"margin-top":"5px"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.page_size),expression:"table.page_size"}],staticStyle:{"border":"1px solid #aaa"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.table, "page_size", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.PAGELENGTHS),function(l){return _c('option',{domProps:{"value":l}},[_vm._v(_vm._s(l))])}),0),_vm._v(" "+_vm._s(_vm.$t('values per page')))]),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"auto"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.table.page),expression:"table.page"}],staticStyle:{"padding":"5px 12px","appearance":"none","border":"0","text-align":"center","border-radius":"3px","cursor":"pointer"},attrs:{"title":_vm.table.page + _vm.$t(' of ') + _vm.pages,"data-placement":"top"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.table, "page", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.pages),function(p){return _c('option',{domProps:{"selected":p == _vm.table.page}},[_vm._v(_vm._s(p))])}),0),_vm._v("\n          "+_vm._s(_vm.$t(' of ') + _vm.pages)+"\n          "),(_vm.pages > 1)?_c('button',{directives:[{name:"disabled",rawName:"v-disabled",value:(1 == _vm.table.page),expression:"1 == table.page"}],staticClass:"btn",attrs:{"title":"Backward","data-placement":"top"},on:{"click":function($event){$event.stopPropagation();_vm.table.page = Number(_vm.table.page) - 1}}},[_vm._v("🞀")]):_vm._e(),_vm._v(" "),(_vm.pages > 1)?_c('button',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.pages == _vm.table.page),expression:"pages == table.page"}],staticClass:"btn",attrs:{"title":"Forward","data-placement":"top"},on:{"click":function($event){$event.stopPropagation();_vm.table.page = Number(_vm.table.page) + 1}}},[_vm._v("🞂")]):_vm._e()])])]),_vm._v(" "),_c('div',{ref:"chart",style:({
        width:    _vm.chart.toggled ? '30%' : '0',
        display:  _vm.chart.toggled ? 'flex' : 'none',
      }),attrs:{"id":"chart_content"}},[_c('div',{staticStyle:{"border-inline":"1px solid hsl(from var(--skin-color) h s calc(l + 30))","min-width":"5px","background-color":"#ddd","cursor":"col-resize","margin":"0 8px","user-select":"none"},on:{"mousedown":function($event){$event.stopPropagation();return _vm.onChartResize.apply(null, arguments)}}})])])]):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-30d34ce1_0", { source: ".grid-item[data-v-30d34ce1]{min-height:80px;border:2px solid;border-radius:4px;background-color:#fff;display:flex;align-items:center}.grid-item[data-v-30d34ce1]:hover{background-color:transparent}.layer-relations[data-v-30d34ce1]{overflow-y:auto}.header[data-v-30d34ce1]{margin:5px 0 10px 0;padding:5px}.layer-relation[data-v-30d34ce1]:not([style*=\"display: none\"]){margin-top:3px;display:flex!important;flex-direction:column}.sub-header[data-v-30d34ce1]{margin-top:5px;margin-bottom:5px;padding:3px;display:flex;justify-content:space-between;align-items:center;width:100%;margin:0!important}.sub-header>.g3w-long-text[data-v-30d34ce1]{border-radius:3px;font-size:1.3em}.table-tools[data-v-30d34ce1]{font-size:1.1em;margin-bottom:3px}.table-tools>.action-button[data-v-30d34ce1]{padding:5px}.header-component[data-v-30d34ce1]{width:100%;display:flex;margin-left:auto;margin-bottom:5px;margin-right:4px}.table-tools .action-button[data-v-30d34ce1]:hover{background-color:transparent}input.form-control.column-search[data-v-30d34ce1]::placeholder{font-weight:400;font-style:italic}input.form-control.column-search[data-v-30d34ce1]{height:25px;min-width:40px;padding:2px}table[data-v-30d34ce1]{width:100%;user-select:none;display:block;height:calc(100% - 60px);overflow:auto;border-collapse:separate}thead[data-v-30d34ce1]{position:sticky;top:0;background-color:#fff}tbody>tr.selected[data-v-30d34ce1]{box-shadow:inset 0 0 0 9999px rgb(13,110,253,.9);color:#fff}tbody>tr[data-v-30d34ce1]:not(.selected):hover{background-color:rgb(255,255,0,.15)}td[data-v-30d34ce1],th[data-v-30d34ce1]{white-space:nowrap}th[data-v-30d34ce1]{cursor:pointer}td[data-v-30d34ce1]{border-top:1px solid rgba(0,0,0,.15)}th.asc[data-v-30d34ce1],th.desc[data-v-30d34ce1]{border-top:var(--skin-color) medium solid}th.asc[data-v-30d34ce1]::after{content:\"▴\"}th.desc[data-v-30d34ce1]::after{content:\"▾\"}.relation-table[data-v-30d34ce1]{display:flex;justify-content:space-between;margin-bottom:5px;margin-top:3px;flex-grow:1;overflow:auto}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-30d34ce1"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Relations.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__